import {useEffect, useMemo} from 'react';
import {useFormContext} from 'react-hook-form';
import {
  getFormDefaultTemplate,
  getFormContentTemplate,
} from '@/utils/help/formUtils';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {FormType} from '@/components/help/common/FormContainer/types';
import {FORM_FIELDS} from '@/constants/help/index';
import {FORM_TYPE_INQUIRY} from '@/constants/help/index';
import {useContentValidation} from '@/hooks/help/useContentValidation';

export const CONTENT_ERROR_MESSAGE = '내용을 입력해 주세요.';
export const CONTENT_MIN_LENGTH_ERROR_MSG = '내용을 5자 이상 입력해 주세요.';

interface UseFormContentOptions {
  type?: FormType;
}

export const useFormContent = ({
  type = FORM_TYPE_INQUIRY,
}: UseFormContentOptions = {}) => {
  const {watch, setValue, formState} = useFormContext();
  const {userId, isMobile} = useHelpContext();
  const isGuest = !userId;

  const contentValue = watch(FORM_FIELDS.CONTENT);
  const mainCategoryValue = watch(FORM_FIELDS.MAIN_CATEGORY);

  // placeholder 캐싱
  const placeholderText = useMemo(() => {
    return getFormDefaultTemplate(type);
  }, [type]);

  // 문의 유형별 템플릿 캐싱
  const template = useMemo(
    () => getFormContentTemplate(type, mainCategoryValue, isGuest, isMobile),
    [type, mainCategoryValue, isGuest, isMobile],
  );

  // 유효성 검사 훅 사용
  const {validateContent} = useContentValidation({template});

  useEffect(() => {
    if (!mainCategoryValue) {
      setValue(FORM_FIELDS.CONTENT, '');
      return;
    }
    setValue(FORM_FIELDS.CONTENT, template, {
      shouldValidate: false,
      shouldDirty: false,
    });
  }, [mainCategoryValue, template, setValue]);

  const charCount = contentValue?.length ?? 0;

  return {
    template,
    placeholderText,
    charCount,
    validateContent,
    errors: formState.errors,
  };
};
